<template>
  <a-modal
    v-if="isVisible"
    v-model:open="isVisibleInternal"
    :title="modalTitle"
    :footer="null"
    :mask-closable="false"
    :closable="false"
    destroy-on-close>
    <div class="tenant-picker__intro">
      {{ modalDescription }}
    </div>

    <div class="tenant-picker__cards">
      <a-card
        v-for="tenant in tenants"
        :key="tenant.companyId"
        hoverable
        class="tenant-card"
        @click="selectTenant(tenant.companyId)">
        <div class="tenant-card__body">
          <img :src="logoFor(tenant)" alt="" class="tenant-card__logo" />
          <div class="tenant-card__text">
            <div class="tenant-card__name">{{ tenant.companyName || tenant.companyId }}</div>
            <div class="tenant-card__roles" v-if="tenant.roles?.length">
              {{ tenant.roles.join(", ") }}
            </div>
          </div>
          <font-awesome-icon
            v-if="tenant.companyId === selectedTenantId?.value"
            :icon="['fal', 'check']"
            class="tenant-card__check" />
        </div>
      </a-card>
    </div>
  </a-modal>
</template>

<script setup>
import { computed, inject, ref, watch } from "vue"

import { i18n } from "@/i18n"

const selectionState = inject("tenantSelectionState", null)
const tenantsRef = inject("tenantCompanies", null)
const selectedTenantId = inject("selectedTenantId", null)
const resolveTenantSelection = inject("resolveTenantSelection", null)
const t = (...args) => i18n.global.t(...args)

const tenants = computed(() => tenantsRef?.value || [])
const isVisible = computed(() => !!selectionState?.visible && tenants.value.length > 0)
const isVisibleInternal = ref(false)

const modalTitle = computed(() =>
  selectionState?.mode === "switch" ? t("tenants.select.switchTitle") : t("tenants.select.title")
)
const modalDescription = computed(() =>
  selectionState?.mode === "switch" ? t("tenants.select.switchDescription") : t("tenants.select.description")
)

watch(
  () => selectionState?.visible,
  (visible) => {
    isVisibleInternal.value = !!visible
  },
  { immediate: true }
)

watch(isVisibleInternal, (open) => {
  if (!open && selectionState) {
    selectionState.visible = false
  }
})

const logoFor = (tenant) => tenant?.logoUrl || require("@/assets/logo-telarya.svg")

const selectTenant = (tenantId) => {
  if (tenantId && typeof resolveTenantSelection === "function") {
    resolveTenantSelection(tenantId)
  }
}
</script>

<style scoped lang="scss">
.tenant-picker__intro {
  margin-bottom: 12px;
  color: var(--Gray);
}

.tenant-picker__cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 12px;
  width: 100%;
}

.tenant-card {
  cursor: pointer;
}

.tenant-card__body {
  display: flex;
  align-items: center;
  gap: 12px;
}

.tenant-card__logo {
  width: 48px;
  height: 48px;
  object-fit: contain;
}

.tenant-card__text {
  flex: 1;
}

.tenant-card__name {
  font-weight: 600;
  line-height: 1.3;
}

.tenant-card__roles {
  font-size: 12px;
  color: var(--Gray);
}

.tenant-card__check {
  color: var(--Primary, #1890ff);
}
</style>
